import { render, staticRenderFns } from "./scientificResearch.vue?vue&type=template&id=586351cf&scoped=true&"
import script from "./scientificResearch.vue?vue&type=script&lang=js&"
export * from "./scientificResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586351cf",
  null
  
)

export default component.exports